var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-blue-300 rounded h-1 transition-all duration-1000",style:({ width: _vm.width })})}
var staticRenderFns = []

export { render, staticRenderFns }